jQuery(document).ready(function () {
    initDnDateTime();
});

var initDnDateTime = function () {
    $('.dnJs-dateTime').each(function () {
        var e = $(this);
        var format = e.attr('data-format');
        var locale = e.attr('data-locale');

        if (typeof locale === "undefined" || locale == '') {
            locale = 'en';
        }

        moment.locale(locale);

        e.datetimepicker({
            format: format,
            locale: locale,
            useCurrent: false,
            icons: {
                time: 'icon-check',
                date: 'icon-calendar',
                up: 'icon-chevron_up',
                down: 'icon-chevron_down',
                previous: 'icon-chevron_left',
                next: 'icon-chevron_right',
                today: 'icon-target',
                clear: 'icon-stop-outline',
                close: 'icon-cross_mark'
            },
            date: moment(e.val(), format).toDate(),
            buttons: {
                showClose: true
            },
        });
        e.on('focusout', function () {
            if (e.val() == '') {
                e.datetimepicker('date', moment().toDate());
            }
        });
    });
};

$(document).on('loaded.bs.modal', '.dnJs-modal-with-dateTime', function (e) {
    initDnDateTime();
});

$(document).on('loaded.form.ajax', function (e) {
    initDnDateTime();
});
